import { FC, useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { ProveedoresEntradas } from "./ProveedoresEntradas/ProveedoresEntradas";

import './proveedoresinternoslayout.css'
import { ProveedoresSalidas } from "./ProveedoresSalidas/ProveedoresSalidas";

export const ProveedoresInternosLayout:FC<any> = (props):JSX.Element => {

  const {entradas, setEntradas, comparativa, stateWarehouseRank, stateNavesRank,stateDonutInternos,stateEntradasProveedorInterno, stateInventario, kpisEntradas,kpisSalidas, escA, escB, filtered, tabID } = props
  
  
  return (
  <div className="proveedoresinternos-layout__wrapper" style={{overflow:'initial'}}> 
    <div className="proveedoresinternos-layout__content" style={{overflow:'initial'}}>
      <div style={{height:'100%',overflow:'initial'}}>
        {
          entradas?
            <ProveedoresEntradas
              comparativa={comparativa}
              stateWarehouseRank={stateWarehouseRank}
              stateNavesRank={stateNavesRank}
              stateInventario={stateInventario}
              kpisEntradas={kpisEntradas}
              escA={escA}
              escB={escB}
              filtered={filtered}
              />
          :
            <ProveedoresSalidas
              comparativa={comparativa}
              stateWarehouseRank={stateWarehouseRank}
              stateNavesRank={stateNavesRank}
              stateInventario={stateInventario}
              kpisSalidas={kpisSalidas}
              stateDonutInternos={stateDonutInternos}
              stateEntradasProveedorInterno={stateEntradasProveedorInterno}
              escA={escA}
              escB={escB}
              filtered={filtered}
              tabID={tabID}
              />
        }
      </div>
    </div>
  </div>
  )
}